const normalizeCta = (data) => {
  const normalizedData = data?.label ? data : null

  return normalizedData
}

export default normalizeCta
